<template>
  <div class="my-1">
    <div v-for="(val, index) in validations" :key="index">
      <div v-if="selectedValidation < 0 || selectedValidation === index">
        <div id="values" class="d-flex flex-row align-items-center py-1">
          <div class="col-md-2 px-0">
            <b-input v-model="val.nome" :placeholder="$lang.PCI.Items.Validation.PlaceholderName" class="mr-2" :disabled="selectedValidation < 0"/>
          </div>
          <div class="col">
            <b-form-select
              name="txtLogicalOperator"
              v-model="val.alertaGrupoID"
              :options="form.alertaGrupoID.options"
              :state="form.alertaGrupoID.state"
              :required="form.alertaGrupoID.required"
              :disabled="selectedValidation < 0"
            >
              <template slot="first">
                <option :value="null">Nenhum</option>
              </template>
            </b-form-select>
          </div>
          <div class="col">
            <b-input v-model="val.mensagem" :placeholder="$lang.PCI.Items.Validation.PlaceholderMessage" class="mr-2" :disabled="selectedValidation < 0"/>
          </div>
          <div class="col-md-2 pr-0">
            <b-checkbox v-model="val.travaEdicao" switch :disabled="selectedValidation < 0">{{$lang.PCI.Items.Validation.LabelBlockEdition}}</b-checkbox>
          </div>
          <div class="col-md-2 pr-0">
            <b-checkbox v-model="val.automatico" switch :disabled="selectedValidation < 0">{{$lang.PCI.Items.Validation.LabelAutomatic}}</b-checkbox>
          </div>
          <div class="d-flex col-md-1 pr-0 justify-content-end">
            <span v-if="selectedValidation < 0" class="px-2" v-b-tooltip.hover="$lang.PCI.Items.Tooltip.CloneValidation">
              <i class="fas fa-clone text-third py-1"
                style="cursor: pointer; font-size: 1rem;"
                @click="onCloneValidation(val)">
              </i>
            </span>
            <b-dropdown v-if="selectedValidation < 0" href="#"
                        variant="link"
                        toggle-class="text-decoration-none p-0"
                        right
                        no-caret
                        tabindex="-1"
                        v-b-tooltip.hover
                        :title="$lang.Common.Tooltip.ButtonDelete">
              <template #button-content>
                <i class="fa fa-trash text-danger p-1"
                  style="cursor:pointer">
                </i>
              </template>
              <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
              <b-dropdown-item href="#" v-on:click="onRemove(index)">{{$lang.Common.Yes}}</b-dropdown-item>
              <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
            </b-dropdown>
            <!-- <span class="px-2" v-if="!(val.regrasValid && val.regrasValid.length)" v-b-tooltip.hover="$lang.PCI.Items.Tooltip.AddValidation">
              <i class="fas fa-tasks text-third py-1"
                style="cursor: pointer; font-size: 1rem;"
                @click="onEditValidation(val, index)">
              </i>
            </span>
            <span class="px-2" v-if="val.regrasValid && val.regrasValid.length" v-b-tooltip.hover="$lang.PCI.Items.Tooltip.EditValidation">
              <i class="fas fa-tasks text-primary py-1"
                style="cursor: pointer; font-size: 1rem;"
                @click="onEditValidation(val, index)">
              </i>
            </span> -->
            <span v-if="selectedValidation < 0" class="px-2" v-b-tooltip.hover="val.regrasValid && val.regrasValid.length
                ? $lang.PCI.Items.Tooltip.EditValidation
                : $lang.PCI.Items.Tooltip.AddValidation">
              <i class="fas fa-pen py-1"
                :class="val.regrasValid && val.regrasValid.length
                  ? 'text-primary'
                  : 'text-third'"
                style="cursor: pointer; font-size: 1rem;"
                @click="onEditValidation(val, index)">
              </i>
            </span>
            <template v-else-if="selectedValidation === index">
              <span class="px-2" v-b-tooltip.hover="$lang.Menu.Common.Back">
                <i class="fas fa-undo text-second py-1"
                  style="cursor: pointer; font-size: 1rem;"
                  @click="onCancel()">
                </i>
              </span>
              <span class="px-2" v-b-tooltip.hover="$lang.PCI.Items.Tooltip.SaveAutomation" >
                <button class="btn p-0 border-0 bg-transparent" :disabled="hasWarnings" @click="onSaveValidation(val)">
                  <i class="fas fa-save py-1"
                    :class="hasWarnings ? 'text-muted' : 'text-third'"
                    :style="{ cursor: hasWarnings ? 'not-allowed' : 'pointer' }">
                  </i>
                </button>
              </span>
            </template>
          </div>
        </div>
      </div>
      <add-validation-automation :itemList="itemList"
                                 :value="editValidation"
                                 :gruposAlerta="gruposAlerta"
                                 tipo="VALIDATION"
                                 v-if="selectedValidation === index"
                                 @Create="onCreateValidationRule"
                                 @Clean="onClearValidationRule"
                                 @validation-warning="hasWarnings = $event">
      </add-validation-automation>
    </div>

    <div class="d-flex flex-row align-items-center py-1" v-if="selectedValidation < 0">
      <b-input :placeholder="$lang.PCI.Items.Validation.PlaceholderNewName"
               v-model="newValidation"
               class="mr-2">
      </b-input>
      <i class="fa fa-plus-circle text-third p-1"
         style="cursor: pointer; font-size: 1rem;"
         @click="onNewValidation">
      </i>
    </div>
  </div>
</template>

<script>
import ItemTreeView from '../components/treeview/ItemTreeView.vue'
import actionsForm from '@/shared/mixins/actionsForm'
import addValidation from './addValidation-form'
import AddValidationAutomation from './addValidationAutomation'
import CompanyMixin from '@/store/module/company/mixin'
import itemMixim from '../mixins/itemMixim'
import { loading, toast } from '@/shared/utils/UIHelper'
import PCIItemRepository from '@/shared/http/repositories/pci/pciItem'
import { uuid } from 'uuidv4'
import { cloneDeep } from 'lodash'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'

export default {
  name: 'AddValidation',
  props: {
    value: Object,
    itemList: Array,
    gruposAlerta: Array
  },
  mixins: [ actionsForm, CompanyMixin, itemMixim ],
  components: {
    ItemTreeView,
    AddValidationAutomation
  },
  data () {
    return {
      validations: [],
      form: addValidation,
      newValidation: null,
      selectedValidation: -1,
      editValidation: null,
      hasWarnings: false
    }
  },
  methods: {
    onLoad () {
      loading.push()
      PCIItemRepository.GetAllGrupos()
        .then(response => {
          if (response.data.code > 0) {
            this.form.alertaGrupoID.options = response.data.data.map(i => {
              return {
                value: i.id,
                text: i.nome
              }
            })
          }
        })
        .finally(() => loading.close())

      loading.push()
      PCIItemRepository.GetAllValidations(this.value.id)
        .then(response => {
          if (response.data.code > 0) {
            this.validations = response.data.data
          }
        })
        .finally(() => loading.close())
    },
    onNewValidation () {
      const data = {
        id: '00000000-0000-0000-0000-000000000000',
        pciModeloItemID: this.value.id,
        nome: this.newValidation,
        mensagem: null,
        alertaGrupoID: null,
        travaEdicao: false,
        status: 1
      }
      this.validations.push(data)
      this.newValidation = null
      const index = this.validations.length - 1
      this.onEditValidation(this.validations[index], index)
    },
    onRemove (index) {
      if (this.validations[index].id === '00000000-0000-0000-0000-000000000000') {
        this.validations.splice(index, 1)
      } else {
        loading.push()
        return PCIItemRepository.DeleteValidation(this.validations[index].id)
          .then(response => {
            if (response.data.code > 0) {
              this.validations.splice(index, 1)
              toast.success(this.$lang.Common.Alerts.Success)
            } else {
              toast.error(this.$lang.Common.Alerts.Error)
            }
            loading.close()
          })
          .catch(err => {
            console.log(err)
            this.onException(err)
          })
      }
    },
    onEditValidation (validation, index) {
      if (this.selectedValidation === index) {
        this.selectedValidation = -1
      } else {
        if (!validation.regrasValid) {
          validation.regrasValid = []
        }
        this.editValidation = validation
        this.selectedValidation = index
      }
    },
    onCloneValidation (validation) {
      const clonedValidation = cloneDeep(validation)

      clonedValidation.id = uuid()

      let counter = 1
      const usedNames = this.validations.map(v => v.nome)

      while (usedNames.includes(clonedValidation.nome)) {
        clonedValidation.nome = `${validation.nome} (${counter})`
        counter++
      }

      const fromTo = {}
      clonedValidation.regrasValid = clonedValidation.regrasValid.map(rv => {
        const newId = uuid()
        fromTo[rv.id] = newId
        rv.id = newId

        if (fromTo[rv.pciModeloItemValidRegraIDPai]) {
          rv.pciModeloItemValidRegraIDPai = fromTo[rv.pciModeloItemValidRegraIDPai]
        }
        return rv
      })

      this.validations.push(clonedValidation)
    },
    onCreateValidationRule (validation) {
      this.editValidation.regrasValid.push(validation)
    },
    onClearValidationRule () {
      this.selectedValidation = -1
      this.editValidation = null
      this.hasWarnings = false
    },
    onSaveValidation (valid) {
      loading.push()
      PCIItemRepository.UpdateValidation(valid)
        .then(response => {
          if (response.data.code > 0) {
            // PCIItemRepository.GetAllValidations(this.value.id, {params: { pciModeloItemStatusId: response.data.data.id }})
            WorkPCIRepository.ValidationByItem(response.data.data.id)
            this.onLoad()
            toast.success(this.$lang.Common.Alerts.Success)
            this.selectedValidation = -1
            this.editValidation = null
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
          loading.close()
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
    },
    onCancel () {
      this.selectedValidation = -1
      this.editValidation = null
      this.hasWarnings = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/items/addValidation.vue